<template>
  <HeaderContent title="Reservation Merge" />
  <ActionContent ctaText="Add Reservation" @action="showModal" @showFilter="modalFilter = !modalFilter"
    v-model:start-date="startDate" v-model:end-date="endDate" v-model:search="search" @search-query="handleSearch" />
  <ReservationStatistic title="Reservation Statistics" :data="statistics" />
  <ReservationForm :modal="modal" :modalReschedule="modalReschedule" :reservationData="reservation"
    @update:reservationData="updateReservation" @update:modal="updateModal" @update:modalReschedule="updateReschedule"
    @addOrUpdate="refreshWithFilters" />

  <ReservationDetail title="Reservation Detail" :uuid="reservationUuid" :data="reservation" v-model="modalDetail"
    :admin-data="adminLogin" @update:modal="modalDetail = $event">
  </ReservationDetail>

  <ReservationPaymentForm :modal="modalPayment" :uuid="reservationUuid" @update:modal="modalPayment = $event"
    @paid="getAll" />

  <ExtrachargeForm :modal="modalExtraCharge" :uuid="reservationUuid" @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="refreshWithFilters" />

  <ReservationFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event" @filter="handleFilter" />
  <ReservationConfirm title="Confirmation" :uuid="reservationUuid" v-model="modalConfirm"
    @confirmed="deleteData(reservationUuid)">
    <template #text>Are you sure to DELETE this this data ?</template>
  </ReservationConfirm>

  <ReservationConfirm title="Confirmation" :uuid="reservationUuid" v-model="modalConfirm" @confirmed="handleConfirm">
    <template #text>
      Are you sure to DELETE this data?
      <!-- {{ modalType === 'delete' ? 'Are you sure to DELETE this data?' : 'Are you sure to VOID this reservation?' }} -->
    </template>
  </ReservationConfirm>

  <ReservationDataTable :data="reservations" :header="headers" :currentPage="currentPage"
    :custom-actions="customActions" />

  <ToastResponse v-model="modalResponse.toast" :text="modalResponse.text" :success="modalResponse.success">
  </ToastResponse>
</template>

<script>
import { ref, inject, onMounted, watch } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ReservationStatistic from "@/components/StatisticData.vue";
import ReservationFilter from "./ReservationFilter.vue";
import ReservationForm from "./ReservationForm.vue";
import ReservationDataTable from "@/components/DataTable.vue";
import ReservationConfirm from "@/components/ModalDialog.vue";
// import iconVoid from "../../../public/icons/rectangle-xmark.svg";
// import iconReserved from "../../../public/icons/receipt.svg";
// import iconCheckIn from "../../../public/icons/clipboard-check.svg";
// import iconCheckOut from "../../../public/icons/door-open.svg";
import iconOverall from "../../../public/icons/square-poll-vertical.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import ToastResponse from "@/components/ToastResponse.vue";
// import {getFormattedDate} from '@/composable/getDateTimeFormatter';
import { formatIDR } from "@/utils/currency";
import ReservationDetail from "./ReservationDetail.vue";
import ReservationPaymentForm from "./ReservationPaymentForm.vue";
// import { getFormattedDate } from "@/composable/getDateTimeFormatter";

export default {
  components: {
    HeaderContent,
    ActionContent,
    ExtrachargeForm,
    ReservationForm,
    ReservationFilter,
    ReservationStatistic,
    ReservationConfirm,
    ReservationDataTable,
    ReservationDetail,
    ToastResponse,
    ReservationPaymentForm,
  },

  setup() {
    const repositories = inject("repositories");
    const reservationMergeRepository = repositories
      ? repositories.reservationMerge
      : null;

    const staffRepository = repositories?.employee;

    const modal = ref(false);
    const modalDetail = ref(false);
    const modalExtraCharge = ref(false);
    const modalReschedule = ref(false);
    const modalPayment = ref(false);
    const selected = ref(null);
    const reservationUuid = ref(null);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const modalType = ref(''); // untuk menyimpan apakah modal delete atau void
    const currentPage = ref(1);
    const types = ref([]);
    const sources = ref([]);
    const payments = ref(["DP", "Lunas"]);
    const data = ref([]);
    const userLogin = ref(null);

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const headers = ref([
      {
        key: "no",
        label: "No",
        sortable: true,
      },
      {
        key: "number",
        label: "Reservation Merge No",
        sortable: true,
      },
      {
        key: "guest.fullname",
        label: "Guest Name",
        sortable: true,
      },
      {
        key: "source.name",
        label: "Source Name",
        sortable: true,
      },
      // {
      //   key: "start",
      //   label: "Arrival",
      //   sortable: true,
      //   formatter: (value) => getFormattedDate(value),
      // },
      // {
      //   key: "end",
      //   label: "Departure",
      //   sortable: true,
      //   formatter: (value) => getFormattedDate(value),
      // },
      // {
      //   key: "days",
      //   label: "Duration",
      //   sortable: true,
      //   tdClass: "text-center",
      // },
      {
        key: "payment_status",
        label: "Payment Status",
        sortable: true,
      },
      {
        key: "pre_payment",
        label: "Prepayment",
        sortable: false,
        tdClass: "text-right",
        formatter: (value) => formatIDR(value),
      },
      {
        key: "grand_total",
        label: "Total Bill",
        sortable: false,
        tdClass: "text-right",
        formatter: (value) => formatIDR(value),
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Res. Invoice",
        variant: "primary",
        icon: "fas fa-file-alt",
        action: async (item) => {
          // console.log(item);

          reservation.value = item;
          //reservationUuid.value = item.uuid;
          modalDetail.value = true;
        },
      },
      {
        label: "Payment",
        variant: "primary",
        icon: "fas fa-money-bill-wave-alt",
        disabled: (item) =>
          item.payment_status === "Full Payment",
        action: (item) => {
          reservationUuid.value = item.uuid;
          modalPayment.value = true;
          console.log(item);
        },
      },
      // {
      //   label: "Reschedule",
      //   variant: "orange",
      //   icon: "fas fa-calendar-day",
      //   disabled: (item) =>
      //     item.status === "Check Out" || item.status === "In House",
      //   action: (item) => {
      //     reservation.value = item;
      //     reservationUuid.value = item.uuid;
      //     modalReschedule.value = true;
      //   },
      // },
      {
        label: "Edit or Reschedule",
        variant: "success",
        icon: "fas fa-edit",
        disabled: (item) =>
          item.payment_status === "Full Payment",
        action: (item) => {
          getById(item.uuid);
        },
      },
      // {
      //   label: "Void",
      //   variant: "danger",
      //   icon: "fas fa-times",
      //   action: (item) => {
      //     showConfirmModal(item.uuid, 'void');
      //     // Implement your delete logic here
      //   },
      // },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        show: () => ['superadmin', 'backoffice', 'supervisor', 'receptionist'].includes(userLogin.value?.role),
        action: (item) => {
          showConfirmModal(item.uuid, 'delete');
          // Implement your delete logic here
        },
      },
      // {
      //   label: "More Options",
      //   variant: "secondary",
      //   icon: "fas fa-caret-square-down", // atau icon dropdown
      //   isDropdown: true,
      //   actions: [
      //     {
      //       label: "Reschedule",
      //       variant: "orange",
      //       icon: "fas fa-calendar-day",
      //       disabled: (item) =>
      //         item.status === "Check Out" || item.status === "In House",
      //       action: (item) => {
      //         reservation.value = item;
      //         reservationUuid.value = item.uuid;
      //         modalReschedule.value = true;
      //       },
      //     },
      //     {
      //       label: "Void",
      //       variant: "danger",
      //       icon: "fas fa-times",
      //       disabled: (item) => item.status !== "Booked",
      //       action: (item) => {
      //         showConfirmModal(item.uuid, 'void');
      //         // Implement your delete logic here
      //       },
      //     }
      //   ],
      // },
    ]);

    const reservations = ref([]);
    const statistics = ref([]);
    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    //const startDate = ref(getCurrentDate);
    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);

    const search = ref("");
    const filterStatus = ref({
      status: null,
    });
    const reservation = ref({});
    // const formatStatusKey = (statusLabel) => {
    //   if (statusLabel === 'Checkout On') {
    //     return 'checkout_on';
    //   }

    //   return statusLabel.toLowerCase().replace(/\s+/g, '');
    // };

    const getAll = async (
      start = null,
      end = null,
      status = null,
      searchQuery = ""
    ) => {
      // *codingan baru naldi*
      // fallback supaya kalau null ambil dari filter/search saat ini
      if (!start) start = startDate.value;
      if (!end) end = endDate.value;
      if (!status) status = filterStatus.value?.status ?? null;
      if (!searchQuery) searchQuery = search.value;

      const params = {};
      // const dateNow = new Date();
      // const todayString = dateNow.toISOString().split("T")[0]; // Format: YYYY-MM-DD

      if (start) params.start = start;
      if (end) params.end = end;
      if (status && status !== "All") params.payment_status = status;
      if (searchQuery) params.search = searchQuery;

      try {
        const res = await reservationMergeRepository.getAll(params);
        const allReservations = res.data.data;

        // filter statistic checkin
        // const checkInsToday = allReservations.filter((item) => {
        //   if (!item.start) return false;
        //   const checkInDate = new Date(item.start).toISOString().split("T")[0];
        //   return checkInDate === todayString;
        // });

        // filter statistic checkout
        // const checkOutsToday = allReservations.filter((item) => {
        //   if (!item.end) return false;
        //   const checkOutDate = new Date(item.end).toISOString().split("T")[0];
        //   return checkOutDate === todayString;
        // });

        // Hitung statistik status
        // const reservedCount = allReservations.filter(
        //   (item) => item.status === "Booked"
        // ).length;

        // const voidCount = allReservations.filter(
        //   (item) => item.status === "Void"
        // ).length;

        reservations.value = allReservations;

        statistics.value = [
          // {
          //   label: "Total",
          //   key: "Reserve",
          //   //value: res.data.statistics.reserved,
          //   value: reservedCount, 
          //   color: "primary",
          //   icon: iconReserved,
          // },
          // {
          //   label: "Total",
          //   key: "CheckIn Today",
          //   value: checkInsToday.length, // Ganti dengan hasil filter hari ini
          //   color: "success",
          //   icon: iconCheckIn,
          // },
          // {
          //   label: "Total",
          //   key: "CheckOut Today",
          //   value: checkOutsToday.length,
          //   color: "warning",
          //   icon: iconCheckOut,
          // },
          // {
          //   label: "Total",
          //   key: "Void",
          //   //value: res.data.statistics.void,
          //   value: voidCount,
          //   color: "danger",
          //   icon: iconVoid,
          // },
          {
            label: "Total",
            key: "Overall",
            value: res.data.statistics.overall,
            color: "primary",
            icon: iconOverall,
          },
        ];
      } catch (err) {
        console.error(err);
      }
    };

    // *codingan baru: naldi*
    const refreshWithFilters = () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value?.status,
        search.value
      );
    };

    const fetchReservations = async () => {
      await getAll(startDate.value, endDate.value);
    };

    const getById = async (uuid) => {
      await reservationMergeRepository
        .getById(uuid)
        .then((res) => {
          modal.value = true;
          reservation.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const showModal = () => {
      modal.value = true;
      reservation.value = {};
    };

    // const showDetailModal = (data) => {
    //   modalDetail.value = true;
    //   reservationUuid.value = data.reservation.uuid;
    //   console.log("data reservasi", reservationUuid.value);
    // };

    const updateModal = (newValue) => {
      modal.value = newValue;
      reservation.value = null;
    };

    const updateReschedule = (newValue) => {
      modalReschedule.value = newValue;
      reservation.value = null;
    };

    const updateReservation = (updatedReservation) => {
      reservation.value = updatedReservation;
    };

    const showConfirmModal = async (uuid, type) => {
      reservationUuid.value = uuid;
      modalType.value = type;  // simpan jenis aksi: 'delete' atau 'void'
      modalConfirm.value = true;
    };

    const voidData = async (uuid) => {
      try {
        await reservationMergeRepository
          .delete(uuid)
          .then(() => {
            //getAll();
            refreshWithFilters();
            modalConfirm.value = false;
            // modalResponse.value.success = true;
            // modalResponse.value.toast = true;
            // modalResponse.value.text = "ini pesan toast"; // ambil pesan dari backend

            Object.assign(modalResponse.value, {
              toast: true,
              success: true,
              text: "Reservation status updated to VOID", // ambil pesan dari backend
            });

            console.log("nilai Modal Response", modalResponse.value);

          })
          .catch((err) => {
            console.log("pesan error", JSON.stringify(err, null, 2));
            modalResponse.value.text = err.response?.data?.message || "Terjadi kesalahan";
            modalResponse.value.success = false;
            modalResponse.value.toast = true;
          })
        // handle success
        // misal ini endpoint API void
        //alert(response.data.message);
        // refresh data atau update UI sesuai kebutuhan
      }
      catch (err) {
        console.error(err);
      }

    }

    const deleteData = async (uuid) => {
      await reservationMergeRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;

          Object.assign(modalResponse.value, {
            toast: true,
            success: true,
            text: "Reservation deleted successfully", // ambil pesan dari backend
          });

          getAll();
        })
        .catch((err) => {
          console.error(err);
          modalResponse.value.text = err.response?.data?.message || "Terjadi kesalahan";
          modalResponse.value.success = false;
          modalResponse.value.toast = true;

        });
    };

    const handleFilter = (filterData) => {
      filterStatus.value = filterData;
      getAll(startDate.value, endDate.value);
    };

    function handleSearch(query) {
      search.value = query;
      getAll(startDate.value, endDate.value, filterStatus.value.status, query);
    }

    function handleConfirm() {
      if (modalType.value === 'delete') {
        deleteData(reservationUuid.value);
      } else if (modalType.value === 'void') {
        voidData(reservationUuid.value);
      }
    }

    watch([startDate, endDate, filterStatus], () => {
      getAll(
        startDate.value,
        endDate.value,
        filterStatus.value.status,
        search.value
      );
    });

    //Get Admin Login
    const adminLogin = ref({});
    const getAdminByUuid = async () => {
      try {
          const user = JSON.parse(localStorage.getItem("user"));
          const uuid = user.employee_uuid;
          const res = await staffRepository.getById(uuid);
          adminLogin.value = res.data.data;
      } catch (e) {
        console.log(e)
      }
    };
    onMounted(() => {
      fetchReservations();
      refreshWithFilters();

      //jika superadmin dari localStorage login tidak perlu panggil
      const user = JSON.parse(localStorage.getItem("user"));
      userLogin.value =  user;
      if (user.role !== 'superadmin') {
        getAdminByUuid();
      }
    });

    return {
      getAll,
      getById,
      filterStatus,
      handleFilter,
      handleSearch,
      handleConfirm,
      search,
      showModal,
      updateModal,
      updateReservation,
      updateReschedule,
      deleteData,
      getCurrentDate,
      startDate,
      endDate,
      sources,
      selected,
      reservationUuid,
      modal,
      modalExtraCharge,
      modalReschedule,
      modalResponse,
      data,
      headers,
      types,
      payments,
      statistics,
      reservation,
      reservations,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions,
      refreshWithFilters,
      modalDetail,
      modalPayment,
      getAdminByUuid,
      adminLogin,
      userLogin,
    };
  },
};
</script>
